/** 检查url是否为站内站点 */
export const checkInstationSite = (path, host) => {
    if (!path) {
        return false
    }
    try {
        const url = new URL(path)
        return url.host.includes(host || 'tvb.com')
    } catch (error) {
        window.console.error(error)
        return false
    }
}

export const getSubpageUrl = data => {
    const { channel, category, id, sort, template } = data
    const hasId = id !== null && id !== undefined

    if (channel && !category && !hasId && !sort && !template) {
        // category.php ===> channel
        return 'category.php'
    } else if (channel && category && !hasId && !sort && !template) {
        // channel.php ===> channel category [parent_cat]
        return 'channel.php'
    }
    return 'content.php'
}
